/* eslint-disable */
import React from 'react';
import { Route } from 'react-router-dom';
import CandidateForm from '../components/CandidateForm';
import ChatView from '../components/ChatView';
import SpoofedChatView from 'components/SpoofedChatView';
import { useSelector } from 'react-redux';

export const routes = {
	HOME: '/',
	THREAD: '/thread',
	SPOOFED_THREAD: '/spoofedthread',
};

const AppRouter = () => {
	const { addForm } = useSelector((state) => state.appReducer);

	return (
		<>
			<Route exact path={routes.HOME} component={addForm ? CandidateForm : ChatView} />
			<Route path={routes.THREAD} component={ChatView} />
			<Route path={routes.SPOOFED_THREAD} component={SpoofedChatView} />
		</>
	);
};

export default AppRouter;
